export const appConfig = {
  socketUrl:
    process.env.NX_MOBILE_SOCKET_URL || 'ws://localhost:3000/mobile/v2',
  apiDomain: process.env.NX_API_DOMAIN || 'http://localhost:3000',
  websiteDomain: process.env.NX_WEBSITE_DOMAIN || 'http://localhost:4210'
};
